import { fetchApi } from '@/config/axiosSetting';
import {
  GetDamagedImageTabsAlertsQueryParamType,
  GetDamagedImageTabsAlertsResponseQueryType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedImageTabsAlerts/getDamagedImageTabsAlertsQuery.type';

export const getDamagedImageTabsAlertsQueryFunctions = (
  params: GetDamagedImageTabsAlertsQueryParamType,
): Promise<GetDamagedImageTabsAlertsResponseQueryType> =>
  fetchApi.get(
    `property/reports/${params.id}/accident_users/damaged/images/entry_tabs/alerts/`,
    {
      params: {
        damaged_id: params.damage_id,
      },
    },
  );
